const drone = {
  "page": {
    "loading": "ドローン画面を読み込んでいます...",
    "projectLoadFailed": "現場情報を読み込めませんでした",
    "projectNoLocation": "現場の位置情報がないため、地図を描画できません",
  },
  "sidebar": {
    "mapping": "マッピング",
    "settings": "ドローン設定",
  },
  "unavailable": {
    "title": "ドローンAPI準備中",
    "body": "Dock APIはまだ接続されていません。開発環境では NEXT_PUBLIC_DRONE_API=mock でモックを確認できます。",
  },
  "access": {
    "locked": "ロールを確認中です — 書き込み操作はロックされています",
    "viewer": "閲覧権限 — Dockの追加・飛行・コマンド・設定は owner のみ可能です",
  },
  "error": {
    "unavailable": "ドローンAPIはまだ準備できていません",
    "forbidden": "権限がありません — owner のみ可能です",
    "not_found": "対象が見つかりませんでした",
    "conflict": "現在の状態と合わないため処理できませんでした",
    "validation": "入力値を確認してください",
    "dock_busy": "Dockが飛行中のため、今は実行できません",
    "network": "リクエストを送信できませんでした — もう一度お試しください",
    "unconfirmed": "リクエストの結果を確認できませんでした — フライト一覧と機体の状態を確認してください",
  },
  "dockBar": {
    "aircraftChange": "新しい機体 {{sn}} を検出しました — 確認するとこのドックに紐付きます",
    "aircraftConfirm": "機体を紐付け",
    "label": "ドローンステーション",
    "add": "Dock追加",
    "empty": "登録されたDockがありません",
    "loadFailed": "Dock一覧を読み込めませんでした",
    "retry": "再読み込み",
    "unbound": "未接続",
    "bindFailed": "バインド失敗",
    "flying": "飛行中",
    "resumeBinding": "{{name}} のバインドを再開",
    "noSelection": "Dockを選択してください — すべての機能は選択したDockが対象です",
    "statusButton": "{{name}} の状態とコマンド",
    "hmsCount": "HMS {{count}}件",
    "hmsNone": "HMSなし",
  },
  "liveness": {
    "live": "正常受信",
    "stale": "受信遅延",
    "offline": "オフライン",
  },
  "status": {
    "altitude": "相対高度",
    "dockTitle": "Dock",
    "aircraftTitle": "機体",
    "mode": "作業モード",
    "cover": "カバー",
    "climate": "空調",
    "temperature": "内部温度",
    "humidity": "湿度",
    "outsideTemperature": "外気温",
    "wind": "風速",
    "network": "ネットワーク",
    "aircraftPower": "機体電源",
    "charge": "機体充電",
    "flightMode": "飛行モード",
    "battery": "バッテリー",
    "remain": "残り飛行時間",
    "speed": "水平速度",
    "lastSeen": "最終受信 {{time}}",
    "staleWarning": "10秒以上状態を受信していません",
    "noTelemetry": "まだ状態を受信していません",
    "aircraftOff": "機体の電源が切れているか、接続されていません",
    "commands": "コマンド",
    "coverOpen": "カバーを開く",
    "coverClose": "カバーを閉じる",
    "powerOn": "機体電源をオン",
    "powerOff": "機体電源をオフ",
    "busy": "飛行中はカバー・機体電源のコマンドを使えません",
    "remove": "Dockを除外",
    "minutesSeconds": "{{minutes}}分{{seconds}}秒",
    "commandSent": "コマンドを送信しました",
    "commandFailed": "{{dock}} · {{command}} コマンドが失敗しました — {{reason}}",
    "commandFailedNoReason": "{{dock}} · {{command}} コマンドが失敗しました",
  },
  "enum": {
    "unknown": "不明({{value}})",
    "dockMode": {
      "0": "待機",
      "1": "現場デバッグ",
      "2": "リモートデバッグ",
      "3": "ファームウェア更新中",
      "4": "作業中",
      "5": "キャリブレーション必要",
    },
    "cover": {
      "0": "閉",
      "1": "開",
      "2": "半開",
      "3": "カバー状態異常",
    },
    "climate": {
      "0": "待機",
      "1": "冷房中",
      "2": "暖房中",
      "3": "除湿中",
      "7": "冷房準備中",
      "8": "暖房準備中",
    },
    "onOff": {
      "0": "オフ",
      "1": "オン",
    },
    "networkQuality": {
      "0": "信号なし",
      "1": "非常に悪い",
      "2": "悪い",
      "3": "普通",
      "4": "良い",
      "5": "非常に良い",
    },
    "aircraftMode": {
      "0": "待機",
      "1": "離陸準備",
      "2": "離陸準備完了",
      "3": "手動飛行",
      "4": "自動離陸",
      "5": "経路飛行",
      "9": "自動帰還",
      "10": "自動着陸",
      "11": "強制着陸",
      "14": "未接続",
    },
  },
  "hms": {
    "title": "HMSアラート",
    "empty": "進行中のアラートはありません",
    "inSky": "飛行中に発生",
    "code": "コード {{code}}",
    "level": {
      "0": "通知",
      "1": "注意",
      "2": "警告",
      "none": "等級なし",
    },
  },
  "binding": {
    "passwordOnce": "パスワードは一度だけ表示されます — 今コピーしてください",
    "moveAsk": "ドック {{sn}} は別のプロジェクトに登録されています。このプロジェクトに移しますか?",
    "moveConfirm": "このプロジェクトに移す",
    "titleAdd": "Dock追加",
    "titleResume": "{{name}} のバインドを再開",
    "stepsLabel": "接続ステップ",
    "steps": {
      "1": "Dock情報",
      "2": "接続値",
      "3": "アプリ入力",
      "4": "接続確認",
    },
    "currentStep": "ステップ {{index}} / 4 — {{name}}",
    "snLabel": "Dock SN",
    "snHelp": "Dock背面のラベル、またはDJIアプリのデバイス情報にあるシリアル番号",
    "nameLabel": "Dock名",
    "register": "接続値を取得",
    "problem": {
      "snRequired": "SNを入力してください",
      "snFormat": "英大文字と数字 6〜32 文字で入力してください",
      "snDuplicate": "このプロジェクトに既に登録されているSNです",
      "nameRequired": "名前を入力してください",
      "nameTooLong": "40文字以内で入力してください",
    },
    "field": {
      "mqttPassword": "MQTT パスワード",
      "org_id": "組織ID",
      "org_name": "組織名",
      "binding_code": "バインドコード",
      "mqtt": "MQTTゲートウェイアドレス",
      "mqttUser": "MQTTアカウント",
      "ntp": "NTPサーバー",
    },
    "onceNotice": "この値は今回の一度だけ表示されます。ウィンドウを閉じると再表示できず、再取得するには再発行が必要です。",
    "reissuedNotice": "再発行しました — 以前の接続値は使用できなくなりました。",
    "guideTitle": "DJIアプリに接続値を入力",
    "guide": {
      "1": "DJI Pilot 2(またはDock設定アプリ)でDockに接続し、「クラウドサービス」を開きます。",
      "2": "「サードパーティクラウド」を選択し、MQTTゲートウェイアドレス・アカウントとNTPサーバーを入力します。",
      "3": "「組織バインド」で組織IDとバインドコードを入力し、Dock名を確認します。",
      "4": "保存するとDockがサーバーに接続します。「次へ」を押して接続を待ってください。",
    },
    "waiting": "Dockが接続してバインドを完了するのを待っています",
    "bound": "バインドが完了しました — DockバーでこのDockを選択できます",
    "failed": "バインドに失敗しました",
    "failure": {
      "invalid_binding_code": "バインドコードが正しくありません",
      "organization_mismatch": "別の組織にバインドされているDockです",
      "license_invalid": "Dockライセンスの検証に失敗しました",
      "sn_mismatch": "接続したDockのSNが登録したSNと異なります",
      "unknown": "サーバーから理由が通知されませんでした",
    },
    "resumeIntro": "以前の接続値は再表示できません。再発行すると以前の値は無効になり、新しい値が一度だけ表示されます。",
    "reissue": "接続値を再発行",
    "next": "次へ",
    "back": "戻る",
    "close": "閉じる",
    "done": "完了",
    "copy": "{{label}}をコピー",
    "copied": "コピーしました",
  },
  "confirm": {
    "previewing": "サーバーがこのコマンドを判定しています",
    "previewFailed": "プレビューを取得できませんでした",
    "notSendable": "今は送信できません",
    "expired": "プレビューの有効時間が過ぎました — 閉じて開き直してください。要求は送信していません。",
    "cancel": "キャンセル",
    "confirm": "確認",
    "title": {
      "aircraft_limits": "機体制限を適用",
      "eventAck": "警報を確認",
      "closeRecord": "クローズ記録",
      "aircraft": "機体を紐付け",
      "cover_open": "カバーを開く",
      "cover_close": "カバーを閉じる",
      "aircraft_power_on": "機体電源をオン",
      "aircraft_power_off": "機体電源をオフ",
      "climate": "空調を変更",
      "pause": "経路を一時停止",
      "resume": "経路を再開",
      "settings": "飛行設定を変更",
      "removeDock": "Dockを除外",
    },
    "body": {
      "aircraft_limits": "{{dock}} の機体に飛行プロファイルの制限値を適用します。",
      "eventAck": "{{dock}} の警報を確認します。確認するとこの警報は離陸を妨げません。",
      "closeRecord": "{{dock}} のクローズ記録を残します — {{reason}}。",
      "aircraft": "{{dock}} に機体 {{sn}} を紐付けます。",
      "cover_open": "{{dock}} のカバーを開きます。",
      "cover_close": "{{dock}} のカバーを閉じます。カバーの下に人や物がないか確認してください。",
      "aircraft_power_on": "{{dock}} の機体電源をオンにします。",
      "aircraft_power_off": "{{dock}} の機体電源をオフにします。",
      "climate": "{{dock}} の空調を「{{mode}}」に変更します。",
      "pause": "{{dock}} の経路飛行を一時停止します。機体はその場でホバリングします。",
      "resume": "{{dock}} の経路飛行を停止した位置から再開します。",
      "settings": "{{dock}} の高度制限を最大 {{max}} m・最低 {{min}} m に変更します。",
      "removeDock": "{{dock}} をこのプロジェクトから除外します。再度使うにはバインドを最初からやり直す必要があります。",
    },
  },
  "leave": {
    "title": "Dockが飛行中です",
    "body": "ページを離れても飛行は続きますが、この画面の帰還ボタンと見守りは使えなくなります。離れますか?",
    "stay": "とどまる",
    "leave": "離れる",
  },
  "launch": {
    "blockedByPreparation": "下の項目を解消すると離陸できます",
    "checkFailed": "未確認",
    "loginRemaining": "ログイン残り時間",
    "loginMinutes": "{{minutes}}分",
    "loginShort": "発射にはログインが 90 分以上残っている必要があります — 再度ログインしてください",
    "title": "飛行実行 — 離陸確認",
    "dock": "対象Dock",
    "plan": "計画",
    "target": "写真を受け取る時系列",
    "figures": "経路 {{distance}} · 写真 約{{photos}}枚 · 約{{minutes}}分",
    "checklistLegend": "項目ごとに自分で確認し、一つずつチェックしてください（記憶しません）",
    "validFor": "プレビューの有効時間 残り{{seconds}}秒",
    "expired": "プレビューの有効時間が過ぎました — もう一度プレビューしてください。リクエストは送信していません。",
    "reopen": "もう一度プレビュー",
    "execute": "離陸",
    "noAutoResend": "期限を過ぎるとリクエストは再送されません",
    "previewing": "サーバーが離陸確認を作成しています",
    "previewFailed": "離陸確認を取得できませんでした — もう一度プレビューしてください",
    "blocked": "現在は離陸できません",
  },
  "safety": {
    "regionLabel": "飛行安全",
    "rth": "帰還",
    "rthAria": "{{dock}} 帰還 — 一度押すとすぐに送信します",
    "rthStage": {
      "sending": "送信中",
      "requested": "リクエスト受付 — Dockの応答待ち",
      "notSent": "3秒以内に受け付けられませんでした — もう一度押してください",
      "refused": "Dockが帰還を拒否しました — {{reason}}",
      "sendFailed": "送信できませんでした — もう一度押してください",
      "sendFailedReason": "送信できませんでした: {{reason}} — もう一度押してください",
      "returning": "帰還中",
      "landed": "着陸完了",
    },
    "rthAccepted": "帰還リクエストを送信しました",
  },
  "attend": {
    "button": "見守り中",
    "aria": "{{dock}} の見守り — 運用者不在時の帰還期限を延長します",
    "sending": "見守りを送信中",
    "ok": "見守り期限まで{{minutes}}分{{seconds}}秒",
    "warning": "見守り期限の{{seconds}}秒前 — 押してください",
    "overdue": "見守り期限切れ — サーバーが帰還を送信します",
    "unknown": "見守り期限が不明",
    "absentReturn": "運用者不在のため帰還を開始しました",
  },
  "login": {
    "hours": "ログイン残り{{hours}}時間{{minutes}}分",
    "minutes": "ログイン残り{{minutes}}分{{seconds}}秒",
    "unknown": "ログイン残り時間が不明",
    "expiring": "ログイン残り15分未満 — まもなくログアウトされます",
    "expired": "ログイン期限切れ — 着陸後に再ログインしてください",
  },
  "live": {
    "connecting": "ライブに接続中です",
    "waitingStream": "ドックの映像送信を待っています",
    "playbackFailed": "ライブを再生できませんでした",
    "title": "{{dock}} ライブ",
    "cameraLabel": "カメラ",
    "camera": {
      "dock": "Dockカメラ",
      "aircraft_wide": "機体 広角",
      "aircraft_zoom": "機体 ズーム",
      "aircraft_ir": "機体 赤外線",
    },
    "open": "ライブを見る",
    "start": "ライブ開始",
    "fullscreen": "全画面",
    "exitFullscreen": "全画面を終了",
    "close": "ライブを閉じる",
    "notStarted": "オンのライブがありません",
    "viewerNotStarted": "owner がライブをオンにすると視聴できます",
    "mockSource": "モック映像",
    "videoLabel": "{{dock}} {{camera}} 映像",
  },
  "mapping": {
    "title": "マッピング",
    "targetLabel": "対象時系列(写真の受け取り先)",
    "targetNone": "対象なし",
    "targetEmpty": "写真を受け取れる before 時系列がありません — プロジェクト画面で時系列を追加してください",
    "substitute": "モック対象の代用",
    "gate": {
      "noTarget": "写真を受け取る before 時系列を選択してください",
      "notInProject": "このプロジェクトの時系列ではありません",
      "notBefore": "この時系列は写真を受け取れる状態(before)ではありません",
      "hasPhotos": "写真を直接アップロードした時系列はDockマッピングの対象ではありません",
      "pending": "時系列を確認中です",
      "unreadable": "時系列一覧を読み込めませんでした",
      "readOnly": "マッピングをリクエストしました — この時系列の計画・写真は読み取り専用です",
    },
  },
  "reference": {
    "label": "基準時系列(成果物・地形)",
    "none": "基準なし",
    "noReferenceWarning": "基準時系列がないため、衝突検証を行いません",
    "layers": "重ねて表示する成果物",
    "ortho": "オルソ画像",
    "dsm": "DSM",
    "gis": "GISレイヤー",
    "gisEmpty": "このプロジェクトにGISレイヤーがありません",
    "no2d": "この基準には2D成果物がありません",
    "model3d": "3Dモデル・BIMは3Dビューで確認します",
  },
  "plans": {
    "deleting": "削除中 — もう一度削除すると完了します",
    "title": "飛行計画",
    "new": "新しい計画",
    "empty": "保存された計画がありません",
    "listLabel": "保存された飛行計画",
    "open": "{{name}} を開く",
    "duplicate": "{{name}} を複製",
    "delete": "{{name}} を削除",
    "deleteTitle": "計画を削除",
    "deleteMessage": "計画「{{name}}」を削除します",
    "deleteSub": "削除すると元に戻せません",
    "import": "他のプロジェクトから取り込む",
    "importTitle": "他のプロジェクトの計画を取り込む",
    "importEmpty": "取り込める計画がありません",
    "importAction": "{{name}} を取り込む",
    "importButton": "取り込む",
    "farWarning": "取り込んだ計画「{{name}}」の領域がこの現場から遠く離れています — 領域を確認してください",
    "kmzBadge": "KMZ",
    "readOnly": "読み取り専用",
    "copySuffix": "(コピー)",
  },
  "area": {
    "title": "マッピング領域",
    "draw": "領域を描く",
    "redraw": "描き直す",
    "drawing": "地図上で点を打ち、ダブルクリックで終了します(Escでキャンセル)",
    "cancel": "描画をキャンセル",
    "none": "領域がありません",
    "points": "頂点 {{count}}個",
  },
  "params": {
    "speedCap": "このドックの上限は {{cap}} m/s です — より速く飛ぶにはドローン設定で上限を上げてください",
    "title": "飛行・撮影設定",
    "name": "計画名",
    "mode": "モード",
    "modes": {
      "single_grid": "シングルグリッド",
      "double_grid": "ダブルグリッド",
      "oblique": "斜め撮影",
    },
    "gridAngle": "グリッド角度 (°)",
    "frontOverlap": "前方オーバーラップ (%)",
    "sideOverlap": "側方オーバーラップ (%)",
    "altitude": "飛行高度 (m)",
    "speed": "速度 (m/s)",
    "camera": "カメラ",
    "cameras": {
      "visible": "可視光",
      "thermal": "赤外線",
      "both": "両方",
    },
    "overlapBasis": "オーバーラップ基準",
    "obliquePattern": "斜めパターン",
    "obliquePatterns": {
      "single_grid": "シングルグリッド",
      "double_grid": "ダブルグリッド",
      "five_direction": "5方向",
    },
    "obliqueTilt": "斜め方向",
    "obliqueTilts": {
      "along_track": "進行方向",
      "cross_track": "横方向",
    },
    "obliqueTiltHelp": "横方向はラインに垂直な2方向を見ます。道路・河川・法面のような長い区域で、長いラインを保ったまま側面を撮るときに使います",
    "gimbalPitch": "カメラ角度 (°)",
    "includeNadir": "オルソパスを含める",
    "sameDirectionOverlap": "同じ向きの写真同士のサイドオーバーラップは {{same}}% です — 足りない場合はサイドオーバーラップを上げるか5方向を使ってください",
    "flightAreaHelp": "描いたマッピング領域は撮影領域です。斜めのラインはその外側の飛行領域まで飛び、領域外の飛行は隣接地の上空を通ります。それを制限するのはDock距離エンベロープだけです",
    "save": "計画を保存",
    "saved": "計画を保存しました",
  },
  "preview": {
    "title": "プレビュー(推定)",
    "figures": "ライン {{lines}} · 写真 約{{photos}}枚 · {{distance}} · 約{{minutes}}分 · GSD {{gsd}} cm/px",
    "invalid": "領域と設定を修正するとプレビューが表示されます",
    "obliqueFigures": "パス {{passes}} · 視線方向 {{directions}} · 斜めGSD {{gsd}} cm/px · 領域外 最大 {{outside}}",
    "covered": "領域全体が危険区域とバッファの内側にあるため、飛行ラインがありません",
  },
  "planForm": {
    "problem": {
      "required": "値を入力してください",
      "notNumber": "数値を入力してください",
      "outOfRange": "{{min}}〜{{max}}の範囲で入力してください",
      "tooLong": "{{max}}文字以内で入力してください",
      "tooFewPoints": "領域を{{min}}点以上で描いてください",
    },
  },
  "hazards": {
    "title": "危険施設・区域",
    "draw": "危険区域を描く",
    "show": "地図に表示",
    "empty": "登録された危険施設・区域がありません",
    "drawing": "地図上で多角形を描いてください(ダブルクリックで終了、Escでキャンセル)",
    "formTitle": "危険施設・区域を保存",
    "kind": {
      "facility": "施設",
      "area": "区域",
    },
    "kindLabel": "種類",
    "name": "名前",
    "height": "高さ (m、任意)",
    "heightValue": "高さ {{height}} m",
    "noHeight": "高さ未指定",
    "save": "保存",
    "cancel": "キャンセル",
    "delete": "{{name}} を削除",
    "alwaysAvoids": "表示をオフにしても経路は常に危険区域から {{buffer}} m 離して作られ、避けられない場合は遮断されます",
    "problem": {
      "nameRequired": "名前を入力してください",
      "height": "0〜1000の数値で入力してください",
    },
  },
  "route": {
    "deleting": "この経路の削除が途中で止まりました — 再度生成してください",
    "profileFailed": "経路断面を読み込めませんでした",
    "title": "経路",
    "generate": "経路を生成・検証",
    "regenerate": "再生成",
    "invalid": {
      "noDock": "DockバーでDockを選択してください",
      "missing": "この計画・Dockの経路がありません — 生成してください",
      "otherDock": "別のDockで作成された経路です — 再生成してください",
      "stalePlan": "計画が変更されました — 再生成してください",
      "hazardsChanged": "危険区域が変更されました — 再生成してください",
      "blocked": "経路が遮断されているため実行できません",
    },
    "block": {
      "hazard": "危険区域「{{name}}」を通過するため遮断されました",
      "hazard_takeoff_inside": "Dockが危険区域「{{names}}」の内側にあるため経路を作成できません",
      "hazard_area_covered": "領域全体が危険区域「{{names}}」とバッファの内側にあるため経路を作成できません",
      "hazard_unreachable": "Dockから到達できる飛行ラインがないため経路を作成できません — 「{{names}}」が道を塞いでいます",
      "hazard_detour_limit": "迂回するとウェイポイント・距離・1回の飛行の上限を超えるため経路を作成できません — 「{{names}}」",
      "hazard_waypoint_inside": "ウェイポイントが危険区域「{{names}}」の内側にあるため経路を作成できません",
    },
    "figures": "ウェイポイント {{waypoints}} · 写真 約{{photos}}枚 · {{distance}} · 約{{minutes}}分",
    "obliqueSummary": "斜め {{pattern}}{{tilt}} · パス {{passes}} · 領域外 最大 {{lead}}",
    "ready": "実行可能な経路です",
    "collision": "衝突の可能性がある区間 {{count}}か所 — 地形・構造物との余裕が {{threshold}} m 未満",
    "noCollision": "基準時系列の断面と衝突の可能性がある区間はありません",
    "noReference": "基準時系列がないため、断面と衝突表示を行いません",
    "needSavedPlan": "計画を保存すると経路を作成できます",
    "avoidance": "危険区域 {{count}} か所を回避 · 迂回 +{{bypass}} · 撮影しない面積 {{area}} m²({{ratio}}%)",
    "warning": {
      "hazard_waypoint_buffer": "経路点が危険区域の緩衝内にあります — {{names}}",
      "hazard_excluded_area": "除外された領域 {{area}} m²({{ratio}}%) — ここは飛行ラインが通りません",
      "hazard_unreachable_part": "接続できず除外した部分 {{area}} m² — 囲まれていて到達できません",
      "hazard_short_fragment": "短い断片 — 除外 {{dropped}} 個({{length}})、残存 {{kept}} 個。残した断片は写真のオーバーラップが不足することがあります",
      "hazard_edge_gap": "高度が低いためバッファ({{buffer}} m)が撮影幅の半分を超えます — 危険区域の縁に写真の空白が生じることがあります",
      "hazard_takeoff_buffer": "Dockが「{{names}}」のバッファの内側にあります",
      "hazard_return_reach": "緊急帰還はDockまで直進するため「{{names}}」の上空を通る可能性があります",
    },
  },
  "legend": {
    "title": "凡例",
    "nadirPass": "鉛直パス {{index}}",
    "obliquePass": "斜めパス {{index}} · 視線方向 {{bearings}}",
    "obliquePassSide": "斜めパス {{index}} · ラインに垂直に視線 {{bearings}}",
    "route": "経路",
    "bypass": "迂回区間",
    "transit": "移動区間(Dock ↔ 経路)",
    "pathStart": "S 開始マーク",
    "pathEnd": "E 終了マーク",
    "returnExposure": "帰還露出区間",
    "collision": "衝突の可能性がある区間",
    "excluded": "除外された領域",
    "unreachable": "接続できない部分",
    "hazard": "危険区域",
    "causeHazard": "原因区域(経路を遮った、または迂回させた区域)",
    "area": "撮影領域(マッピング領域)",
    "flightArea": "飛行領域 · 領域外 最大 {{outside}}",
    "waypoint": "ウェイポイント",
    "photo": "撮影点",
    "sight": "視線表示",
    "dock": "ドック",
    "dockScene": "ドックと帰還高度線",
  },
  "profile": {
    "title": "経路断面",
    "aria": "経路断面 — 距離 {{distance}} における地形と飛行高度、衝突の可能性がある区間 {{count}}か所",
    "terrain": "地形",
    "flight": "飛行",
    "collision": "衝突の可能性",
  },
  "flight": {
    "aircraftPending": "機体接続を確認中",
    "profileIncomplete": "飛行プロファイルが不完全です — ドローン設定で入力してください",
    "title": "飛行",
    "run": "飛行実行",
    "phase": {
      "preparing": "準備中",
      "takeoff": "離陸",
      "en_route": "進入",
      "mapping": "撮影",
      "returning": "帰還",
      "landing": "着陸",
      "landed": "着陸完了",
      "failed": "失敗",
    },
    "paused": "一時停止中",
    "pause": "一時停止",
    "resume": "再開",
    "progress": "ウェイポイント {{index}}/{{total}} · {{percent}}%",
    "battery": "バッテリー {{percent}}%",
    "photos": "累計写真 {{count}}枚",
    "openLive": "ライブ",
    "needRoute": "実行可能な経路がありません",
    "dockBusy": "このDockは既に飛行中です",
    "needTarget": "写真を受け取る対象時系列を選択してください",
    "launched": "離陸リクエストを送信しました",
  },
  "request": {
    "title": "マッピングリクエスト",
    "action": "マッピングをリクエスト",
    "flying": "飛行中はリクエストできません",
    "noPhotos": "まだ写真を受信していません",
    "substituteTitle": "代用時系列のマッピングリクエスト",
    "substituteBody": "モック対象の代用のため、実際のサーバーには送信せず、この画面の状態のみ変更します。",
    "done": "リクエスト完了",
  },
  "flightCheck": {
    "terrainVersion": "検証した地形の版: {{version}}",
    "title": "飛行検証",
    "run": "飛行検証を実行",
    "rerun": "再検証",
    "passed": "合格 · {{time}}",
    "problem": {
      "unchecked": "飛行検証をまだ行っていません",
      "failed": "飛行検証に合格していません",
      "stale": "記録が古くなっています — 再検証してください",
    },
    "stale": {
      "profile_changed": "飛行プロファイルが変更された",
      "hazards_changed": "危険区域が変更された",
      "terrain_changed": "地形が変更された",
      "validator_changed": "検証器が変更された",
      "validator_unreviewed": "未レビューの検証器",
      "kmz_changed": "経路ファイルが変更された",
    },
  },
  "preparation": {
    "title": "飛行準備",
    "residual": "このドックの前回の飛行が閉じていません — 着陸を確認して記録してください",
    "eventNotFound": "この画面では警報を見つけられませんでした — {{reason}}(事象 {{id}})。事象番号で別の方法から確認してください。",
    "limitsIntro": "機体の電源を入れ、プロファイルの制限を適用し、電源を切ります。各段階をサーバーが判定します。電源が入ってから次へ進んでください。",
    "power": "機体電源: {{state}}",
    "stepSent": "送信済み",
    "stepRun": "実行",
    "done": "準備を終える",
    "closeIntro": "サーバーが捉えられなかった着陸を人が残す記録です。機体の場所を自分で確認して選んでください。",
    "closeNext": "プレビュー",
    "reasonLabel": "理由",
    "noteLabel": "メモ(任意)",
    "action": {
      "limits": "機体制限の準備",
      "ack": "警報を確認",
      "close": "クローズ記録",
    },
    "step": {
      "power_on": "機体の電源を入れる",
      "limits": "機体制限を適用",
      "power_off": "機体の電源を切る",
    },
    "reason": {
      "in_dock_visual": "ドック内(目視)",
      "landed_outside_visual": "ドック外に着陸(目視)",
      "recovered_outside_dock": "ドック外で回収",
      "lost": "紛失",
      "destroyed": "破損",
    },
    "reasonHint": {
      "in_dock_visual": "機体がドック内にあるのを目で確認しました。次の飛行準備にはこの記録が必要です。",
      "landed_outside_visual": "機体がドック外に着陸したのを目で確認しました。",
      "recovered_outside_dock": "機体をドック外で回収しました。",
      "lost": "機体を見つけられませんでした。",
      "destroyed": "機体が破損しました。",
    },
  },
  "settings": {
    "profile": "飛行プロファイル",
    "profileUnreadable": "保存されたプロファイルを読めません",
    "incomplete": "プロファイルが不完全です — 飛行操作は開きません",
    "digest": "保存された digest {{digest}}",
    "groupRequired": "必須項目",
    "groupLimits": "飛行限界",
    "groupTakeoff": "離陸条件",
    "groupWatch": "監視・操縦の値",
    "positionSuggested": "ドックが報告した位置を入力しました — 確認して保存すると値になります",
    "fieldRequired": "値を入力してください",
    "fieldRange": "{{min}}〜{{max}}",
    "saveProfile": "プロファイルを保存",
    "confirmChanged": "変更項目: {{fields}}",
    "confirmNoChange": "なし",
    "confirmDigest": "新しい digest の先頭 8 文字: {{digest}}",
    "confirmComplete": "保存するとプロファイルは完全です",
    "confirmIncomplete": "保存しても不完全です: {{problems}}",
    "aircraftLimits": "機体制限の期待値",
    "changes": "変更履歴",
    "changesEmpty": "変更履歴はまだありません",
    "climateSaved": "保存されたモード: {{mode}}",
    "climateSave": "モードを保存",
    "field": {
      "latitude": "ドック緯度",
      "longitude": "ドック経度",
      "height_m": "ドック楕円体高 (m)",
      "dock_position": "ドック位置",
      "max_distance_m": "最大距離 (m)",
      "max_height_m": "最大高度 (m)",
      "min_height_m": "最低高度 (m)",
      "rth_altitude_m": "帰還高度 (m)",
      "permit_ceiling_m": "許可上限 (m)",
      "max_speed_mps": "最大速度 (m/s)",
      "temp_min_c": "最低気温 (℃)",
      "temp_max_c": "最高気温 (℃)",
      "max_wind_mps": "最大風速 (m/s)",
      "min_battery_pct": "最小バッテリー (%)",
      "min_gnss_quality": "GNSS 品質の下限",
      "min_gps_number": "衛星数の下限",
      "link_stable_s": "途切れない接続 (秒)",
      "breach_margin_m": "逸脱監視の余裕 (m)",
      "position_tolerance_m": "ドック位置の許容差 (m)",
      "attend_timeout_s": "オペレーター不在監視 (秒)",
      "telemetry_lost_s": "テレメトリ途絶判定 (秒)",
      "route_max_points": "経路点数の上限",
      "hover_max_s": "ホバー上限 (秒)",
      "stick_max_deflection": "スティック最大偏向",
      "stick_session_max_s": "操縦セッション長 (秒)",
      "stick_floor_m": "スティック下限 (m, off 可)",
      "stick_descent_mps": "下限投影の下降速度",
      "climate_mode": "ドック空調モード",
      "obstacle_avoidance": "障害物検知",
    },
    "title": "ドローン設定",
    "selectDock": "DockバーでDockを選択してください",
    "viewOnly": "閲覧権限 — 設定を変更できません",
    "loadFailed": "設定を読み込めませんでした",
    "climate": "Dock内部温度",
    "climateCurrent": "現在 {{temperature}} · {{state}}",
    "climateModes": {
      "off": "オフ",
      "cooling": "冷房",
      "heating": "暖房",
    },
    "climateApply": "空調を適用",
    "envelopeAria": "高度エンベロープ — 最低 {{min}} m から最大 {{max}} m の間で飛行",
    "obstacle": "障害物検知",
    "obstacleOn": "オン",
    "obstacleNote": "オフにする操作はこの画面から送信しません",
    "kmz": "KMZアップロード",
    "kmzSelect": "KMZファイルを選択",
    "kmzNote": "アップロードした経路は計画一覧に読み取り専用で追加されます。変更されないため危険区域を通ると遮断され、高度エンベロープの検証も受けます",
    "kmzOnly": "KMZ(.kmz)ファイルのみアップロードできます",
    "kmzDone": "「{{name}}」を取り込みました",
  },
  "map": {
    "flatBase3d": "3D成果物がないため、衛星の平面ベース(地形なし)に描画します",
    "dock": "{{name}} Dock",
    "aircraft": "{{name}} 機体",
    "readOnly3d": "3Dは閲覧専用です — 描画は2Dで行います",
  },
  "units": {
    "meters": "{{value}} m",
    "kilometers": "{{value}} km",
    "celsius": "{{value}} ℃",
    "percent": "{{value}}%",
    "mps": "{{value}} m/s",
  },
} as const;

export default drone;
